import { render, staticRenderFns } from "./AuthPanel.vue?vue&type=template&id=035e27a4"
import script from "./AuthPanel.vue?vue&type=script&lang=ts"
export * from "./AuthPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports